import {
  StudentPerformanceReview,
  ReviewStatus,
  PerformanceRating,
  StudentGrade,
  PerformanceSummary,
} from '../../views/modules/analytics/performance/performance.interfaces';

export const mockStudentPerformanceReviews: StudentPerformanceReview[] = [
  {
    id: 'student-1',
    studentId: 'STU001',
    name: 'Arjun Sharma',
    grade: StudentGrade.GRADE_10,
    section: 'A',
    reviewPeriod: 'Q2 2024',
    reviewDate: '2024-07-15',
    reviewer: 'Mrs. Priya Gupta (Class Teacher)',
    status: ReviewStatus.COMPLETED,
    overallRating: PerformanceRating.EXCELLENT,
    overallScore: 92,
    comments:
      'Arjun consistently demonstrates exceptional academic performance and leadership qualities. He actively participates in class discussions and helps other students.',
    strengths: [
      'Strong analytical thinking',
      'Excellent communication skills',
      'Natural leadership abilities',
      'Consistent academic performance',
    ],
    areasForImprovement: [
      'Time management during exam preparation',
      'Participation in sports activities',
    ],
    goals: [
      'Improve physical fitness and sports participation',
      'Maintain academic excellence',
      'Develop project management skills',
    ],
    nextReviewDate: '2024-10-15',
    academicPerformance: {
      gpa: 9.2,
      attendance: 96,
      subjectScores: [
        {
          subject: 'Mathematics',
          score: 95,
          grade: 'A+',
          remarks: 'Outstanding problem-solving skills',
        },
        {
          subject: 'Physics',
          score: 92,
          grade: 'A+',
          remarks: 'Excellent grasp of concepts',
        },
        {
          subject: 'Chemistry',
          score: 90,
          grade: 'A+',
          remarks: 'Good practical skills',
        },
        {
          subject: 'English',
          score: 88,
          grade: 'A',
          remarks: 'Strong writing abilities',
        },
        {
          subject: 'Computer Science',
          score: 94,
          grade: 'A+',
          remarks: 'Exceptional programming skills',
        },
      ],
    },
    behavioralAssessment: {
      discipline: PerformanceRating.EXCELLENT,
      participation: PerformanceRating.EXCELLENT,
      teamwork: PerformanceRating.GOOD,
      leadership: PerformanceRating.EXCELLENT,
    },
    extracurricularActivities: [
      'Debate Club Captain',
      'Science Olympiad',
      'Student Council Member',
    ],
    parentFeedback:
      "Very satisfied with Arjun's progress. Grateful for the teacher's guidance.",
  },
  {
    id: 'student-2',
    studentId: 'STU002',
    name: 'Priya Patel',
    grade: StudentGrade.GRADE_9,
    section: 'B',
    reviewPeriod: 'Q2 2024',
    reviewDate: '2024-07-18',
    reviewer: 'Mr. Rajesh Kumar (Mathematics Teacher)',
    status: ReviewStatus.COMPLETED,
    overallRating: PerformanceRating.GOOD,
    overallScore: 78,
    comments:
      'Priya shows good potential but needs to work on consistency. Her performance varies across subjects.',
    strengths: [
      'Creative thinking',
      'Good artistic abilities',
      'Helpful nature',
      'Active in cultural activities',
    ],
    areasForImprovement: [
      'Mathematics problem solving',
      'Regular homework completion',
      'Time management',
    ],
    goals: [
      'Improve mathematics scores',
      'Maintain consistent study schedule',
      'Participate in more academic competitions',
    ],
    nextReviewDate: '2024-10-18',
    academicPerformance: {
      gpa: 7.8,
      attendance: 89,
      subjectScores: [
        {
          subject: 'Mathematics',
          score: 70,
          grade: 'B',
          remarks: 'Needs more practice with complex problems',
        },
        {
          subject: 'English',
          score: 85,
          grade: 'A',
          remarks: 'Excellent creative writing',
        },
        {
          subject: 'History',
          score: 82,
          grade: 'A',
          remarks: 'Good understanding of concepts',
        },
        {
          subject: 'Art',
          score: 92,
          grade: 'A+',
          remarks: 'Outstanding artistic talent',
        },
        {
          subject: 'Biology',
          score: 76,
          grade: 'B+',
          remarks: 'Good theoretical knowledge',
        },
      ],
    },
    behavioralAssessment: {
      discipline: PerformanceRating.GOOD,
      participation: PerformanceRating.SATISFACTORY,
      teamwork: PerformanceRating.EXCELLENT,
      leadership: PerformanceRating.SATISFACTORY,
    },
    extracurricularActivities: [
      'Art Club',
      'Cultural Committee',
      'School Magazine Editor',
    ],
    parentFeedback:
      'Please provide additional support in mathematics. Priya enjoys school overall.',
  },
  {
    id: 'student-3',
    studentId: 'STU003',
    name: 'Rohit Singh',
    grade: StudentGrade.GRADE_11,
    section: 'C',
    reviewPeriod: 'Q2 2024',
    reviewDate: '2024-07-20',
    reviewer: 'Ms. Sunita Devi (Chemistry Teacher)',
    status: ReviewStatus.IN_PROGRESS,
    overallRating: PerformanceRating.SATISFACTORY,
    overallScore: 65,
    comments:
      'Rohit is working hard to improve his academic performance. Recent efforts show positive signs.',
    strengths: [
      'Determined attitude',
      'Good sports performance',
      'Respectful behavior',
      'Punctual attendance',
    ],
    areasForImprovement: [
      'Study techniques',
      'Subject comprehension',
      'Assignment quality',
      'Class participation',
    ],
    goals: [
      'Achieve 75% in next quarterly exam',
      'Improve study habits',
      'Seek help when needed',
    ],
    nextReviewDate: '2024-10-20',
    academicPerformance: {
      gpa: 6.5,
      attendance: 94,
      subjectScores: [
        {
          subject: 'Physics',
          score: 62,
          grade: 'C+',
          remarks: 'Needs conceptual clarity',
        },
        {
          subject: 'Chemistry',
          score: 68,
          grade: 'B-',
          remarks: 'Improving gradually',
        },
        {
          subject: 'Mathematics',
          score: 60,
          grade: 'C+',
          remarks: 'Requires more practice',
        },
        {
          subject: 'English',
          score: 72,
          grade: 'B',
          remarks: 'Good communication skills',
        },
        {
          subject: 'Physical Education',
          score: 88,
          grade: 'A',
          remarks: 'Excellent athletic abilities',
        },
      ],
    },
    behavioralAssessment: {
      discipline: PerformanceRating.EXCELLENT,
      participation: PerformanceRating.SATISFACTORY,
      teamwork: PerformanceRating.GOOD,
      leadership: PerformanceRating.SATISFACTORY,
    },
    extracurricularActivities: [
      'Basketball Team',
      'Sports Captain',
      'Environmental Club',
    ],
  },
  {
    id: 'student-4',
    studentId: 'STU004',
    name: 'Ananya Reddy',
    grade: StudentGrade.GRADE_12,
    section: 'A',
    reviewPeriod: 'Q2 2024',
    reviewDate: '2024-07-22',
    reviewer: 'Dr. Vikram Rao (Principal)',
    status: ReviewStatus.COMPLETED,
    overallRating: PerformanceRating.EXCELLENT,
    overallScore: 95,
    comments:
      'Ananya is an exemplary student who serves as a role model for others. Her dedication and achievements are commendable.',
    strengths: [
      'Outstanding academic performance',
      'Exceptional leadership skills',
      'Strong work ethic',
      'Excellent interpersonal skills',
    ],
    areasForImprovement: ['Work-life balance', 'Delegation skills'],
    goals: [
      'Prepare for competitive entrance exams',
      'Mentor junior students',
      'Develop stress management techniques',
    ],
    nextReviewDate: '2024-10-22',
    academicPerformance: {
      gpa: 9.5,
      attendance: 98,
      subjectScores: [
        {
          subject: 'Mathematics',
          score: 97,
          grade: 'A+',
          remarks: 'Exceptional analytical skills',
        },
        {
          subject: 'Physics',
          score: 94,
          grade: 'A+',
          remarks: 'Strong conceptual understanding',
        },
        {
          subject: 'Chemistry',
          score: 93,
          grade: 'A+',
          remarks: 'Excellent practical work',
        },
        {
          subject: 'English',
          score: 96,
          grade: 'A+',
          remarks: 'Outstanding communication',
        },
        {
          subject: 'Computer Science',
          score: 98,
          grade: 'A+',
          remarks: 'Advanced programming skills',
        },
      ],
    },
    behavioralAssessment: {
      discipline: PerformanceRating.EXCELLENT,
      participation: PerformanceRating.EXCELLENT,
      teamwork: PerformanceRating.EXCELLENT,
      leadership: PerformanceRating.EXCELLENT,
    },
    extracurricularActivities: [
      'Head Girl',
      'Robotics Club President',
      'National Science Olympiad',
      'Model UN Delegate',
    ],
    parentFeedback:
      "Extremely proud of Ananya's achievements. Thank you for nurturing her talents.",
  },
  {
    id: 'student-5',
    studentId: 'STU005',
    name: 'Vikash Kumar',
    grade: StudentGrade.GRADE_8,
    section: 'B',
    reviewPeriod: 'Q2 2024',
    reviewDate: '2024-07-25',
    reviewer: 'Mrs. Meera Joshi (English Teacher)',
    status: ReviewStatus.PENDING,
    overallRating: PerformanceRating.NEEDS_IMPROVEMENT,
    overallScore: 55,
    comments:
      'Vikash needs additional support to reach his potential. Regular monitoring and intervention required.',
    strengths: [
      'Good at hands-on activities',
      'Creative problem solving',
      'Friendly personality',
      'Shows improvement with guidance',
    ],
    areasForImprovement: [
      'Reading comprehension',
      'Mathematical concepts',
      'Attention span',
      'Homework completion',
    ],
    goals: [
      'Complete assignments on time',
      'Improve reading skills',
      'Attend extra help sessions',
      'Develop better study habits',
    ],
    nextReviewDate: '2024-09-25',
    academicPerformance: {
      gpa: 5.5,
      attendance: 85,
      subjectScores: [
        {
          subject: 'Mathematics',
          score: 45,
          grade: 'D',
          remarks: 'Needs fundamental concept revision',
        },
        {
          subject: 'English',
          score: 58,
          grade: 'C-',
          remarks: 'Improving with extra support',
        },
        {
          subject: 'Science',
          score: 52,
          grade: 'C-',
          remarks: 'Good in practical work',
        },
        {
          subject: 'Social Studies',
          score: 60,
          grade: 'C+',
          remarks: 'Shows interest in current events',
        },
        {
          subject: 'Art',
          score: 75,
          grade: 'B+',
          remarks: 'Natural artistic ability',
        },
      ],
    },
    behavioralAssessment: {
      discipline: PerformanceRating.SATISFACTORY,
      participation: PerformanceRating.NEEDS_IMPROVEMENT,
      teamwork: PerformanceRating.GOOD,
      leadership: PerformanceRating.NEEDS_IMPROVEMENT,
    },
    extracurricularActivities: ['Art Club', 'Gardening Club'],
    parentFeedback:
      'Please provide additional academic support. We are committed to helping Vikash improve.',
  },
];

export const mockStudentPerformanceSummary: PerformanceSummary = {
  totalReviews: 5,
  completedReviews: 3,
  pendingReviews: 1,
  overdueReviews: 1,
  averageRating: 7.6,
  ratingDistribution: {
    excellent: 2,
    good: 1,
    satisfactory: 1,
    needsImprovement: 1,
    unsatisfactory: 0,
  },
};
